"use strict";

var qs = require('querystring');
var url = require('url');
var _require = require('./utils'),
  authResponse = _require.authResponse,
  sanitizeOptions = _require.sanitizeOptions;
var authWindow = require('../authWindow');
module.exports = oAuth2TokenFlow;

/**
 * Trigger the client-side implicit OAuth2 flow.
 * Reference: http://tools.ietf.org/html/rfc6749#section-4.2
 *
 * @param {Object}   options
 * @param {Function} done
 */
function oAuth2TokenFlow(options) {
  try {
    options = sanitizeOptions(options);
  } catch (error) {
    return Promise.reject(error);
  }
  if (typeof options.clientId !== 'string') {
    return Promise.reject(new TypeError('"clientId" expected'));
  }
  if (typeof options.authorizationUri !== 'string') {
    return Promise.reject(new TypeError('"authorizationUri" expected'));
  }
  return new Promise(function (resolve, reject) {
    var state = "".concat(Math.random()).substr(2);
    var popup = authWindow("".concat(options.authorizationUri, "?").concat(qs.stringify({
      state: state,
      scope: options.scope,
      client_id: options.clientId,
      response_type: 'token',
      redirect_uri: options.redirectUri
    })), function (err) {
      if (err) {
        reject(err);
      }
      resolve();
    });
    global.authenticateOAuth = function (href) {
      popup.close();
      delete global.authenticateOAuth;
      var uri = url.parse(href, true);
      var response = Object.assign(qs.parse((uri.hash || '').substr(1)), uri.query);
      if (href.substr(0, options.redirectUri.length) !== options.redirectUri) {
        reject(new Error('Invalid redirect uri'));
        return;
      }
      if (response.state !== state) {
        reject(new Error('State mismatch'));
        return;
      }

      // Pass the response off for validation. At least Instagram has a bug where
      // the state is being passed back as part of the query string instead of the
      // hash, so we merge both options together.
      resolve(authResponse(options, response));
    };
  });
}
//# sourceMappingURL=token.js.map